import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Play, CheckCircle2, Shield, Zap } from 'lucide-react';

const DemoSection = () => {
  const { t } = useLanguage();
  
  return (
    <section className="demo-section">
      <div className="demo-background">
        <img 
          src="https://images.unsplash.com/photo-1648113139950-4ea1237f6d84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwaHlkcmF1bGljJTIwcGFydHN8ZW58MHx8fHwxNzc2MDcwMDAwfDA&ixlib=rb-4.1.0&q=85"
          alt="Industrial parts"
          className="demo-bg-image"
        />
        <div className="demo-overlay"></div>
      </div>
      
      <div className="section-container">
        <div className="demo-content-grid">
          <div className="demo-video-container">
            <div className="video-placeholder">
              <button className="play-button" aria-label="Play demo video">
                <Play size={48} fill="white" />
              </button>
              <div className="video-label">{t('watchDemo')}</div>
            </div>
          </div>
          
          <div className="demo-info">
            <h2 className="demo-title">{t('demoTitle')}</h2>
            <p className="demo-subtitle">{t('demoSubtitle')}</p>
            
            <ul className="demo-features">
              <li className="demo-feature">
                <CheckCircle2 className="feature-icon-check" size={24} />
                <span>{t('demoFeature1')}</span>
              </li>
              <li className="demo-feature">
                <Shield className="feature-icon-check" size={24} />
                <span>{t('demoFeature2')}</span>
              </li>
              <li className="demo-feature">
                <Zap className="feature-icon-check" size={24} />
                <span>{t('demoFeature3')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoSection;
